import React, { useState, useEffect, useRef } from "react";
import { Modal, Icon, Table, Loader } from "semantic-ui-react";
import SortBoxEndpoints from "../../lib/sortbox/SortBoxEndpoints";
import SortBoxRow from "./SortBoxRow";
import "./LeftoverOrders.css";

const LeftoverOrders = ({ open, onClose, workstationID, operatorID, callback }) => {
  //const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [activeRow, setActiveRow] = useState(-1);

  useEffect(() => {
    async function getData() {
      setLoading(true);
      await SortBoxEndpoints.getLeftoverOrders(workstationID, operatorID)
        .then((response) => {
          setRows(response);
        })
        .catch((err) => {
          //setError(err);
        })
        .finally(() => {
          console.log("sätter false");
          setLoading(false);
        });
    }
    getData();
  }, []);

  const openSortBox = (boxID) => {
    boxID = `X${boxID}`;

    callback(boxID);
  };

  const onRowClick = (index) => {
    if (index === activeRow) {
      return;
    }
    setActiveRow(index);
  };

  const sortBoxes = () => {
    const newRows = rows.map((box, index) => {
      return (
        <SortBoxRow
          operatorID={operatorID}
          workstationID={workstationID}
          key={index}
          box={box}
          activeRow={activeRow}
          index={index}
          setActiveRow={onRowClick}
          onButtonClick={() => openSortBox(box.boxID)}
        ></SortBoxRow>
      );
    });

    return newRows;
  };

  const table = () => {
    return (
      <Table fixed celled striped>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell className="tableCell">Box</Table.HeaderCell>
            <Table.HeaderCell className="tableCell">Utskriven</Table.HeaderCell>
            <Table.HeaderCell className="tableCell">Fakturanummer</Table.HeaderCell>
            <Table.HeaderCell className="tableCell">Fakturadatum</Table.HeaderCell>
            <Table.HeaderCell className="tableCell">Ordernummer</Table.HeaderCell>
            <Table.HeaderCell className="tableCell">Vagnsnummer</Table.HeaderCell>
            <Table.HeaderCell className="tableCell">Namn</Table.HeaderCell>
            <Table.HeaderCell className="tableCell">Listtyp</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>{sortBoxes()}</Table.Body>
      </Table>
    );
  };

  const isLoading = () => {
    if (loading) {
      return (
        <Loader size="massive" className="workaround">
          Laddar ordrar
        </Loader>
      );
    }
    return null;
  };

  return (
    <Modal
      className="leftoverOrdersModal workaround"
      size="large"
      open={open}
      onClose={onClose}
      closeOnEscape={true}
      closeOnDimmerClick={true}
    >
      {isLoading()}
      <Modal.Header className="leftoverOrdersHeader">
        <p>Överblivna ordrar</p>
        <Icon onClick={onClose} className="closeCross" name="close"></Icon>
      </Modal.Header>
      <Modal.Content>{rows.length === 0 ? null : table()}</Modal.Content>
    </Modal>
  );
};

export default LeftoverOrders;
